import React, { useEffect, useRef } from 'react'
import { useSnackbar } from 'notistack'
import { Grid } from '@mui/material'
import { useForm } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import postService from '../../../services/postService'
import PostForm from '../PostForm'

const CreatePostPage = () => {
  const [tabValue, setTabValue] = React.useState('text')
  const editorRef = useRef(null)
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const methods = useForm({ mode: 'onChange' })

  const { communityId } = useParams()

  useEffect(() => {
    if (communityId) {
      methods.setValue('communityId', communityId)
    }
  }, [])

  const submitHandler = ({ communityId, title, body, images, link }) => {
    const form = { title }
    form.type = tabValue
    form.communityId = communityId
    if (tabValue === 'text') {
      form.body = body
    } else if (tabValue === 'images') {
      form.images = methods.getValues('images')
      console.log(form.images)
    } else if (tabValue === 'link') {
      form.link = link
    }
    return postService.createPost({
      ...form
    })
      .then(res => {
        enqueueSnackbar('Successfully uploaded!.', { variant: 'success' })
        navigate('/home')
      })
      .catch(err => enqueueSnackbar(err.response.data.message, { variant: 'error' }))
  }

  return (
    <Grid container>
      <PostForm postFormTitle="Create Post" methods={methods} onSubmit={submitHandler} tabValue={tabValue} setTabValue={setTabValue} editorRef={editorRef}/>
    </Grid>
  )
}

export default CreatePostPage
